import patient from '@/sui/data/sheets/edit/patient'
import tools from '@/sui/data/sheets/edit/tools'
import ice from '@/sui/tools/ice'
import assert from '@/sui/tools/assert'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'
import clone from 'clone'
import {
  checkAge,
  checkDate,
  checkCompresses,
  checkGlovesPutOn
} from '@/sui/data/sheets/edit/notes/observa4'

import v2021 from '@/sui/data/sheets/edit/observa4/2021'

const result = clone(v2021)

function rename (object, oldKey, newKey) {
  assert.notNull(object, `rename: missing object`)
  assert.notNull(oldKey, `rename: missing old key`)
  assert.notNull(newKey, `rename: missing new key`)
  assert.notNull(object[oldKey], `rename: invalid old key ${oldKey}`)
  delete Object.assign(object, { [newKey]: object[oldKey] })[oldKey]
}

result.rename = rename
rename(result.fields.audited, 'p1p3', 'p1p3p4')
rename(result.fields.auditedCleanOutfit, 'p2p3b1b2', 'p2p3p4b1b2')
rename(result.fields.patientCleanOutfit, 'p1p2p3b2', 'p1p2p3p4b2')
rename(result.fields.handHygieneBeforePreparation, 'p2p3', 'p2p3p4')
rename(result.fields.dirtySkin, 'p1p2p3', 'p1p2p3p4')
rename(result.fields.insertionSiteCleaned, 'p1p2p3', 'p1p2p3p4')
rename(result.fields.antiseptic, 'p1p2p3', 'p1p2p3p4')
rename(result.fields.useCompresses, 'p1p2p3', 'p1p2p3p4')
rename(result.fields.compressesType, 'p1p2p3', 'p1p2p3p4')
rename(result.fields.antisepticPassages, 'p1p2p3', 'p1p2p3p4')
rename(result.fields.dry, 'p1p2p3', 'p1p2p3p4')
rename(result.fields.handHygieneBeforePeriInsertion, 'p2', 'p2p4')
rename(result.fields.gloves, 'p1p2p3b1', 'p1p2p3p4b1')
rename(result.fields.glovesType, 'p1p2p3b1', 'p1p2p3p4b1')
rename(result.fields.whyNotAlcool, 'p1p2p3', 'p1p2p3p4')
rename(result.fields.whyNotHH, 'p2', 'p2p4')
rename(result.fields.whyNotGloves, 'p2', 'p2p4')

//     UPDATE    obsManagment (list)    obsManagment>config>values: different sizes
result.fields.obsManagment.all.config.values = go.fields2022.obsManagment

// +++ ADD       isEhpad (list)
result.fields.isEhpad = {
  p4: tools.cfg.list(
    fields.isEhpad, 'EHPAD', go.fields.yesNo, { sel: result.select.p4 }
  )
}

// +++ ADD       p4type (list)
result.fields.catheterType.p4 = tools.cfg.list(
  `p4${fields.catheterType}`, result.fields.catheterType.p1.config.title,
  go.fields2023.p4Type, { sel: result.select.p4, srv: fields.catheterType }
)

// +++ ADD       p1p3p4auditedDetail (text)
result.fields.auditedDetail = {
  p1p3p4: tools.cfg.text(
    `p1p3p4${fields.auditedDetail}`,
    `Préciser la catégorie professionnelle`, {
      sel: tools.allTrue(
        result.select.p1p3p4,
        tools.equals(result.fields.audited.p1p3p4.field, 5)
      ),
      srv: fields.auditedDetail
    }
  )
}

//     UPDATE    b1CompressAntiseptic (list)b1CompressAntiseptic>config>values: different sizes
result.fields.antiseptic.b1[1].config.values = go.fields.antisepticNo7

// +++ ADD       holdTissue (list)
result.fields.holdTissue = {
  p4: tools.cfg.list(
    fields.holdTissue, `Maintien du tissu sous-cutané entre le pouce et l'index`,
    go.fields.yesNo, { sel: result.select.p4 }
  )
}

// +++ ADD       glovesNecessary (list)
result.fields.glovesNecessary = {
  b1: tools.cfg.list(
    fields.glovesNecessary, `Le port des gants est-il nécessaire pour ce branchement ?`,
    go.fields.yesNo, { sel: result.select.b1 }
  )
}

// +++ ADD       glovesPutOn (list)
result.fields.glovesPutOn = {
  p2p4: tools.cfg.list(
    fields.glovesPutOn, 'Gants enfilés', go.fields2023.glovesPutOn, {
      sel: tools.allTrue(
        result.select.p2p4, result.select.yes(result.fields.gloves.p1p2p3p4b1.field)
      )
    }
  )
}

// --- REMOVE    glovesJustified (list)
delete result.fields.glovesJustified

// +++ ADD       whyNotSterileGloves (list)
// +++ ADD       whyNotSterileGlovesDetail (text)
result.fields.whyNotSterileGloves = {
  b2: result.build.why(
    '', fields.whyNotSterileGloves,
    `Pourquoi l'opérateur ne porte-t-il pas de gants stériles ?`,
    tools.allTrue(
      result.select.b2,
      tools.different(result.fields.glovesType.b2.field, 2)
    ),
    go.fields2024.whyNotSterileGloves,
    5
  )
}

// +++ ADD       whyNotHHCompliant (list)
// +++ ADD       whyNotHHCompliantDetail (text)
result.fields.whyNotHHCompliant = {
  p2: result.build.why(
    '', fields.whyNotHHCompliant,
    `Pourquoi la technique de l'hygiène des mains par friction n'est-elle pas conforme ?`,
    tools.allTrue(
      result.select.p2,
      result.select.no(result.fields.handHygieneBeforePeriInsertion.p2p4[2].field),
      tools.equals(result.fields.handHygieneBeforePeriInsertion.p2p4[1].field, 1)
    ),
    go.fields.whyNotHHCompliant,
    5
  )
}

//     UPDATE    b2whyNotHHM (list)     b2whyNotHHM>config>values>3>value: different values (4. Hygiène des mains jugée inutile / 4. Jugée inutile)
result.fields.whyNotHHM.b2[0].config.values = go.fields.whyNotHHM

result.rename(result.titles.audited, 'p1p3', 'p1p3p4')
result.titles.patient.p4 = result.build.title(
  'LE PATIENT / RÉSIDENT', result.fields.patientCleanOutfit.p1p2p3p4b2, false, result.select.p4
)

result.build.titleFrom = function (reference, field, selector) {
  return result.build.title(
    reference.text, field, reference.hiddenWhenFieldIgnored,
    selector, reference.type
  )
}

result.titles.insertionSite = {
  p1p2p4: result.build.titleFrom(
    result.titles.insertionSite.p1p2,
    result.fields.handHygieneBeforePreparation.p2p3p4[0],
    result.select.p1p2p4
  ),

  p3: result.titles.insertionSite.p3
}

result.titles.insertion.p2p4 = result.build.titleFrom(
  result.titles.insertion.p2,
  result.fields.handHygieneBeforePeriInsertion.p2p4[0],
  result.select.p2p4
)
delete result.titles.insertion.p2

result.sheet = {
  titles: [
    result.titles.audited.p1p3p4,
    result.titles.audited.p2b1b2,
    result.titles.patient.p1p2p3b2,
    result.titles.patient.p4,
    result.titles.insertionSite.p3,
    result.titles.insertionSite.p1p2p4,
    result.titles.manipulation.b1,
    result.titles.manipulation.b2,
    result.titles.insertion.p1,
    result.titles.insertion.p2p4,
    result.titles.insertion.p3,
    result.titles.interview.all
  ],

  fields: [
    result.fields.obsManagment.all,
    ...tools.addSelect(result.select.obs, [
      patient.sheetNumber.v2,
      result.fields.obsDate.all
    ]),
    result.fields.isEhpad.p4,
    ...tools.addSelect(result.select.obs, [
      tools.opts(patient.unitType.v1.rw, { sp: 'unitType' }),
      patient.uf
    ]),
    result.fields.place.p1,
    result.fields.otherPlace.p1,
    result.fields.catheterType.p1,
    result.fields.catheterType.p2,
    result.fields.catheterType.b1,
    result.fields.catheterType.b2,
    result.fields.catheterType.p4,
    result.fields.otherCatheterType.p1,
    result.fields.otherCatheterType.b1,
    result.fields.otherCatheterType.b2,
    result.fields.audited.p1p3p4,
    result.fields.audited.p2b1b2,
    result.fields.auditedDetail.p1p3p4,
    result.fields.student.all,
    result.fields.auditedCleanOutfit.p2p3p4b1b2,
    result.fields.sterileGown.p1,
    result.fields.auditedCap.p1p3,
    result.fields.compliantAuditedCap.p1p3,
    result.fields.gloves.b2,
    result.fields.glovesType.b2,
    result.fields.auditedMask.p1p3b2,
    result.fields.compliantAuditedMask.p1p3b2,
    result.fields.isAdult.p1p2p3,
    result.fields.childAge.p1p2p3,
    result.fields.patientCleanOutfit.p1p2p3p4b2,
    result.fields.patientMask.p1p3b2,
    result.fields.compliantPatientMask.p1p3b2,
    result.fields.patientSterileField.p1,
    result.fields.patientOtherSide.p3b2,
    result.fields.patientCap.p1,
    result.fields.compliantPatientCap.p1,

    ...result.fields.handHygieneBeforePreparation.p2p3p4,
    ...result.fields.handHygieneBeforeManip.b1,
    ...result.fields.handHygieneBeforeGloves.b2,

    result.fields.dirtySkin.p1p2p3p4,
    result.fields.insertionSiteCleaned.p1p2p3p4,
    ...result.fields.antiseptic.p1p2p3p4,
    result.fields.useCompresses.p1p2p3p4,
    result.fields.useCompresses.b1b2,
    result.fields.compressesType.p1p2p3p4,
    result.fields.compressesType.b1b2,
    ...result.fields.antiseptic.b1,
    ...result.fields.antiseptic.b2,
    result.fields.valve.b1b2,
    ...result.fields.valveAntiseptic.b1b2,
    result.fields.antisepticPassages.p1p2p3p4,
    result.fields.dry.p1p2p3p4,

    ...result.fields.handHygieneBeforeInsertion.p1,
    ...result.fields.handHygieneBeforePeriInsertion.p2p4,
    ...result.fields.handHygieneBeforePuncture.p3,

    result.fields.holdTissue.p4,
    result.fields.glovesNecessary.b1,
    result.fields.gloves.p1p2p3p4b1,
    result.fields.glovesType.p1p2p3p4b1,
    result.fields.glovesPutOn.p2p4,
    result.fields.palpation.p2,

    ...result.fields.whyNCAuditedOutfit.p1p3,
    ...result.fields.whyNotSterileGloves.b2,
    ...result.fields.whyNotAuditedMask.b2,
    ...result.fields.whyNCPatientOutfit.p3b2,
    ...result.fields.whyNotAlcool.p1p2p3p4,
    ...result.fields.whyNotHHC.p1,
    ...result.fields.whyNotHH.p2p4,
    ...result.fields.whyNotHHP.p3,
    ...result.fields.whyNotHHCompliant.p2,
    ...result.fields.whyNotGloves.p2p4,
    ...result.fields.whyNotHHM.b1,
    ...result.fields.whyNotHHM.b2,
    ...result.fields.whyNotCompresses.b1,
    ...result.fields.whyNotSterileCompresses.b1,
    ...result.fields.whyNotDisinfectValve.b1b2
  ],

  buildNotes: function (resultNotes, sheet) {
    checkAge(
      resultNotes, sheet, {
        unitType: patient.unitType.v1.rw.field,
        isAdult: result.fields.isAdult.p1p2p3.field,
        childAge: result.fields.childAge.p1p2p3.field
      }
    )
    checkDate(
      resultNotes, sheet, '2022', {
        obsDate: result.fields.obsDate.all
      }
    )
    checkCompresses(
      resultNotes, sheet, {
        antiseptic: result.fields.antiseptic.p1p2p3p4[1].field,
        useCompresses: result.fields.useCompresses.p1p2p3p4.field
      }
    )
    checkGlovesPutOn(
      resultNotes, sheet, {
        gloves: result.fields.gloves.p1p2p3p4b1.field,
        glovesPutOn: result.fields.glovesPutOn.p2p4.field,
        handHygieneBeforePeriInsertion: result.fields.handHygieneBeforePeriInsertion.p2p4[0].field,
        whyNotHH: result.fields.whyNotHH.p2p4[0].field
      }
    )
    return resultNotes
  }
}

result.assertAllFieldsAreUsed('2022')
export default ice.freeze(result, 10)
